import React, { useEffect } from "react";
import "./DiscoverSection.css";
import DiscoverImage from "../DiscoverImage/DiscoverImage";
import DiscoverContent from "../DiscoverContent/DiscoverContent";
import QuoteButton from "../QuoteButton/QuoteButton";

const DiscoverSection = () => {

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    document
      .querySelectorAll("[data-animate]")
      .forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-section">
      <div className="container">

        <h2 className="section-title" data-animate>
          Get To Know Us
        </h2>

        <div className="glass three-split">

          <div data-animate>
            <DiscoverImage />
          </div>

          <div className="stagger" data-animate>
            <DiscoverContent />
          </div>

          <div className="stagger" data-animate>
            <QuoteButton />
          </div>

        </div>

      </div>
    </section>
  );
};

export default DiscoverSection;
